export default __webpack_public_path__ + "static/media/step-1.16bc9093.svg";